module.exports = __webpack_public_path__ + "img/help.042492bd.svg";